import { __ } from '@web-stories-wp/i18n';
import { INNER_GLOW_MAX_SIZE } from '../../../../elements/text/utils/getTextInnerGlow';

export const SOURCE_OPTIONS = [
  { value: 'edge', label: __('Edge', 'web-stories') },
  { value: 'center', label: __('Center', 'web-stories') },
];
export const CONTOUR_OPTIONS = [
  { value: 'linear', label: __('Linear', 'web-stories') },
  { value: 'smooth', label: __('Smooth', 'web-stories') },
  { value: 'ring', label: __('Ring', 'web-stories') },
];

// Provisional authoring defaults, in document pixels; not Photoshop UI limits.
export const DEFAULTS = {
  version: 1,
  enabled: false,
  color: '#ffffff',
  opacity: 14,
  size: 12.5,
  choke: 0,
  range: 50,
  blendMode: 'screen',
  technique: 'softer',
  source: 'edge',
  contour: 'linear',
  noise: 0,
  jitter: 0,
  antiAlias: false,
};
export const FIELDS = [
  {
    key: 'opacity',
    label: __('Inner glow opacity', 'web-stories'),
    suffix: __('Opacity', 'web-stories'),
    max: 100,
    unit: '%',
    section: 'appearance',
  },
  {
    key: 'size',
    label: __('Inner glow size', 'web-stories'),
    suffix: __('Size', 'web-stories'),
    max: INNER_GLOW_MAX_SIZE,
    unit: 'px',
    section: 'falloff',
  },
  {
    key: 'choke',
    label: __('Inner glow choke', 'web-stories'),
    suffix: __('Choke', 'web-stories'),
    max: 100,
    unit: '%',
    section: 'falloff',
  },
  {
    key: 'range',
    label: __('Inner glow range', 'web-stories'),
    suffix: __('Range', 'web-stories'),
    min: 1,
    max: 100,
    unit: '%',
    section: 'falloff',
  },
];
export function settingsFor(element) {
  return element.textInnerGlow?.version === 1
    ? { ...element.textInnerGlow }
    : { ...DEFAULTS };
}
